export const INVOICE_NUMBERING_MODES = {
  TIMESTAMPED: "timestamped",
  SEQUENTIAL: "sequential",
} as const;

export type InvoiceNumberingMode = (typeof INVOICE_NUMBERING_MODES)[keyof typeof INVOICE_NUMBERING_MODES];

export const DEFAULT_INVOICE_SEQUENTIAL_START = 25001;

export const INVOICE_NUMBERING_MODE_LABELS: Record<InvoiceNumberingMode, string> = {
  timestamped: "Legacy",
  sequential: "Sequential",
};

export type InvoiceNumberingState = {
  invoiceNumberingMode: InvoiceNumberingMode;
  invoiceNextNumber: number | null;
};

export type InvoiceNumberingDraft = {
  invoiceNumberingMode: InvoiceNumberingMode;
  invoiceStartNumber: string;
  hasStoredNextNumber: boolean;
};
